import React from "react";
import type { FC, JSX, PropsWithChildren } from "react";

import { createDisplayNameForUniCardElement } from "../../utils/getDisplayName";
import { createTestIdForUniCardElement } from "../../utils/getTestId";

import classes from "./UniCardBottom.styl";

const UNI_CARD_BOTTOM_TEST_ID = createTestIdForUniCardElement("bottom");

interface IUniCardBottom extends PropsWithChildren {}

export const UniCardBottom: FC<IUniCardBottom> = ({
    children,
}): JSX.Element => {
    return (
        <div className={classes["bottom"]} data-tsid={UNI_CARD_BOTTOM_TEST_ID}>
            {children}
        </div>
    );
};

UniCardBottom.displayName = createDisplayNameForUniCardElement("Bottom");

export default UniCardBottom;
